const sharedSettings = {
  name: { editable: true, type: 'input', rules: [{ required: true }] },
  description: { editable: true, type: 'textarea', rules: [{ required: false }] },

  code: { editable: true, type: 'input', rules: [{ required: false }] },
  user_type: { editable: true, type: 'habit-usertype-select', rules: [{ required: false }] },

  default_order: { editable: true, type: 'number' },
  area_icon: { editable: true, type: 'picture' },

  color_code_1: { editable: true, type: 'input', rules: [{ required: false }] },
  color_code_2: { editable: true, type: 'input', rules: [{ required: false }] },

  created_at: { hidden: true },
  updated_at: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  name: "",
  description: "",
  code: "",
  default_order: "",
  area_icon: null,
  color_code_1: "",
  color_code_2: "",
  user_type: "",
};
